import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Table, Button, Typography, Input, Space, Form, DatePicker, Select, Row, Col,Card,Grid } from "antd";
import { PlusCircleFilled,EditOutlined,PlayCircleOutlined, DownloadOutlined } from "@ant-design/icons";
import moment from 'moment';

import Add from "./Add";
import useAxios from "../../../CustomHooks/useAxios";
import PageLink from "../../PageLink/PageLink";
const { useBreakpoint } = Grid;
export default function HDTicket() {
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 20,
    total: 0
  });

  const { axiosi } = useAxios();

  const screens = useBreakpoint();

  const fetchData = async (params = {}) => {
    setLoading(true);
    try {
      const values = await form.validateFields();
      const searchParams = {
        page: params.current || 1,
        pageSize: params.pageSize || 20,
        ...params,
        fromDate: values.fromDate?.format('YYYY-MM-DD'),
        toDate: values.toDate?.format('YYYY-MM-DD'),
        type: values.type,
        ivrKey: values.ivrKey,
        ticketStatus: values.ticketStatus,
        ext: values.ext,
      };

      const response = await axiosi.get('/hdticket', { params: searchParams });

      setData(response.data.rows);
      setPagination({
        ...pagination,
        total: response.data.numrows,
        current: response.data.page,
        pageSize: response.data.pageSize,
      });
    } catch (error) {
      console.error('Error fetching tickets:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleTableChange = (newPagination, filters, sorter) => {
    fetchData({
      ...newPagination,
      ...filters,
      ...sorter,
    });
  };

  const handleSearch = () => {
    fetchData({
      current: 1,
      pageSize: pagination.pageSize
    });
  };

  const renderMobileCard = (record) => (
    <Card
      key={record.id}
      style={{ marginBottom: 16 }}
      actions={[
        <Button type="link" icon={<EditOutlined />} onClick={() => handleEdit(record)}>Edit</Button>,
        <Button type="link" icon={<PlayCircleOutlined />} onClick={() => handlePlay(record)}>Play</Button>,
        <Button type="link" icon={<DownloadOutlined />} onClick={() => handleDownload(record)}>Download</Button>
      ]}
    >
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Typography.Title level={5}>Thông tin chung</Typography.Title>
          <p><strong>Ngày:</strong> {moment(record.created_at).format('DD/MM/YYYY HH:mm:ss')}</p>
          <p><strong>Trạng thái:</strong> {record.status}</p>
          <p><strong>TicketID:</strong> {record.ticket_id}</p>
        </Col>
        
        <Col span={24}>
          <Typography.Title level={5}>Thông tin khách hàng</Typography.Title>
          <p><strong>Mã KH:</strong> {record.customer_id}</p>
          <p><strong>Tên:</strong> {record.customer_name}</p>
          <p><strong>SĐT:</strong> {record.phone}</p>
        </Col>

        <Col span={24}>
          <Typography.Title level={5}>Thông tin ticket</Typography.Title>
          <p><strong>IVR Key:</strong> {record.ivr_key}</p>
          <p><strong>Phân loại:</strong> {record.type}</p>
          <p><strong>Nội dung:</strong> {record.customer_note}</p>
          <p><strong>Hướng xử lý:</strong> {record.solution}</p>
        </Col>

        <Col span={24}>
          <Typography.Title level={5}>Thông tin xử lý</Typography.Title>
          <p><strong>Agent:</strong> {record.agent_name} ({record.agent_code})</p>
          <p><strong>Deadline:</strong></p>
          <p>LA: {record.la_deadline ? moment(record.la_deadline).format('DD/MM/YYYY HH:mm:ss') : 'N/A'}</p>
          <p>RA: {record.ra_deadline ? moment(record.ra_deadline).format('DD/MM/YYYY HH:mm:ss') : 'N/A'}</p>
        </Col>
      </Row>
    </Card>
  );
  const handleExport = () => {
    // Implement export functionality
  };

  // const columns = [
  //   {
  //     title: 'ID',
  //     dataIndex: 'id',
  //     key: 'id',
  //   },
  //   // Thêm các cột khác tùy theo cấu trúc dữ liệu của bảng hdticket
  // ];

  // ... existing code ...

  const columns = [
    {
      title: '#',
      dataIndex: 'id',
      key: 'id',
      width: 60
    },
    {
      title: 'Ngày',
      key: 'date',
      render: (text, record) => (
        <>
          <div>Ngày: {record.ngay	}</div>
          <div>Giờ: {moment(record.ngay	).format('HH:mm:ss')}</div> <br/>

          <div>Agent Code: {record.agentcode	}</div>
          <div>Agent Name: {record.agentname	}</div>
        </>
      ),
      width: 150
    },
    {
      title: 'Đơn vị',
      key: 'unit',
      render: (text, record) => (
        <>
          <div>MaKH: {record.makh	}</div>
          <div>Tên: {record.tendonvi	}</div> <br/>
          
          <div>SĐT: {record.sdt	}</div>
          <div>Email: {record.email}</div>
          <div>Kênh: {record.kenh	}</div>
        </>
      ),
      width: 200
    },
    {
      title: 'Nội dung',
      key: 'content',
      render: (text, record) => (
        <>
          <div>ivrKey: {record.ivrkey	}</div>
          <div>Hãng: {record.hang	}</div>
          <div>Phân loại: {record.phanloainame		}</div> <br/>

          <div>Phát sinh lỗi: {record.phatsinhloi	}</div>
          <div>Lỗi do ai: {record.loidoai}</div>
          <div>Phòng/bộ phận: {record.phongbanname}</div>
          <div>Lý do: {record.lydoname}</div> <br/>

          <div>Nội dung khiếu nại: {record.noidungkhieunai}</div>
          <div>Hướng xử lý: {record.huongxuly}</div>
          <div>Giải pháp khắc phục: {record.giaiphapkhacphuc}</div>
          <div>Ghi chú: {record.ghichu}</div>

          <div>First Awareness (FA): {record.chfanote}</div>
          <div>Resolution Respond (RR): {record.chrrnote}</div>

          
        </>
      ),
      width: 400
    },
    {
      title: 'Trạng thái',
      key: 'status',
      render: (text, record) => (
        <>
          <div>Tình trạng: {record.tinhtrang}</div>
          <div>TicketID: {record.id}</div>
          <div>So ID: {record.soid}</div>
          <div>Source: {record.sourcetk}</div>
          <div>Ngày mở: {moment(record.opentickettime).format('YYYY-MM-DD HH:mm:ss')}</div>
          <div>Ngày đóng: {record.closetickettime ? moment(record.closetickettime).format('YYYY-MM-DD HH:mm:ss') : ''}</div>
          <div>RA deadline: {record.la_deadline ? moment(record.la_deadline).format('YYYY-MM-DD HH:mm:ss') : ''}</div>
          <div>RR deadline: {record.ra_deadline ? moment(record.ra_deadline).format('YYYY-MM-DD HH:mm:ss') : ''}</div>
        </>
      ),
      width: 200
    },
    {
      title: 'Thao tác',
      key: 'action',
      render: (text, record) => (
        <Space>
          <Button type="link" onClick={() => handleEdit(record)}>Edit Ticket</Button>
          <Button type="link" onClick={() => handlePlay(record)}>Play</Button>
          <Button type="link" onClick={() => handleDownload(record)}>Download</Button>
        </Space>
      ),
      width: 150,
      fixed: 'right'
    }
  ];



  const renderContent = () => {
    if (!screens.md) {
      return (
        <div style={{ padding: '0 16px' }}>
          {data.map(record => renderMobileCard(record))}
        </div>
      );
    }

    return (
      <Table
        columns={columns}
        dataSource={data}
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
        rowKey="id"
        scroll={{ x: true }}
      />
    );
  };
  const handleEdit = (record) => {
    // Implement edit functionality
  };

  const handlePlay = (record) => {
    // Implement play audio functionality
  };

  const handleDownload = (record) => {
    // Implement download functionality
  };

// ... existing code ...

  return (
    <div>
      <Form form={form} layout="vertical" initialValues={{ fromDate: moment() }}>
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item name="fromDate" label="From:">
              <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="toDate" label="To:">
              <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="type" label="Type:">
              <Select>
                <Select.Option value="Tel">Tel</Select.Option>
                {/* Thêm các option khác nếu cần */}
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="search" label="Search:">
              <Input placeholder="Search..." />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item name="ivrKey" label="IVRKey:">
              <Select placeholder="- IVRKey -">
                {/* Thêm các option từ API */}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="ticketStatus" label="Ticket Status:">
              <Select placeholder="- Ticket Status -">
                {/* Thêm các option từ API */}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="ext" label="Ext:">
              <Select placeholder="- Ext -">
                {/* Thêm các option từ API */}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={24}>
            <Space>
              <Button type="primary" onClick={handleSearch}>Search</Button>
              <Button onClick={handleExport}>Export</Button>
              <Button onClick={handleSearch}>Search Issue Summary</Button>
              <Button onClick={handleExport}>Export Issue Summary</Button>
            </Space>
          </Col>
        </Row>
      </Form>

      <div style={{ marginTop: 16 }}>
        <Space style={{ marginBottom: 16 }}>
          <Typography.Title level={4}>HD Tickets</Typography.Title>
          <Button 
            type="primary" 
            icon={<PlusCircleFilled />}
            onClick={() => setVisibleAdd(true)}
          >
            Add New
          </Button>
        </Space>

        {visibleAdd && (
        <Add 
          visible={visibleAdd}
          onClose={() => setVisibleAdd(false)}
          onSuccess={() => {
            setVisibleAdd(false);
            fetchData();
          }}
        />
      )}

        {/* <Table
          columns={columns}
          dataSource={data}
          pagination={pagination}
          loading={loading}
          onChange={handleTableChange}
          rowKey="id"
        /> */}
        {renderContent()}
      </div>
    </div>
  );
}